// Textos del Control Trimestral ampliado (régimen fiscal, IGIC, 111, 202, avisos y envío a la gestoría).
import de from "./trim/de";
import it from "./trim/it";
import nl from "./trim/nl";
import fr from "./trim/fr";
import ro from "./trim/ro";
import ru from "./trim/ru";
import ar from "./trim/ar";
import zh from "./trim/zh";

const es = {
  avisoLegal: "Borrador orientativo generado a partir de los datos registrados en NuvliPro. No sustituye el asesoramiento profesional. Revísalo con tu gestoría antes de presentarlo.",
  lockPago: "Las exportaciones para gestoría son una función de pago.",
  imp: { IVA: "IVA", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Territorio común", canarias: "Canarias", ceuta_melilla: "Ceuta y Melilla", foral_pv: "País Vasco", foral_navarra: "Navarra" },
  tipo: { autonomo: "Autónomo (persona física)", sociedad: "Sociedad" },
  q: { 1: "1T · Ene–Mar", 2: "2T · Abr–Jun", 3: "3T · Jul–Sep", 4: "4T · Oct–Dic" },
  periodoT: "{{n}}T {{year}}",
  periodoP: "{{n}}P {{year}}",
  sub: "{{imp}} e IRPF por trimestre y resumen anual",
  pie: "Los importes se calculan automáticamente a partir de tus facturas emitidas y gastos registrados por trimestre.",
  regimen: {
    proTitulo: "Plan Pro:",
    proTexto: "régimen fiscal automático por territorio (IVA, IGIC y Haciendas Forales), Modelo 420 en Canarias, Modelo 202 para sociedades, Modelo 111, avisos de plazos y revisión de la calidad de los datos.",
    pasarPro: "Pasarme al Pro",
    modelo: " (modelo {{m}})",
    pagos: "pagos a cuenta: modelo {{m}}",
    corregido: "Corregido a mano · cambiar",
    detectado: "Detectado automáticamente · corregir",
    faltan: "Falta tu {{que}} fiscal: se ha supuesto territorio común y autónomo hasta que lo completes.",
    cp: "código postal", nif: "NIF/CIF", y: " y ",
    foral: "Tu domicilio fiscal está en {{nombre}}: el IVA y los pagos a cuenta se presentan en la {{hacienda}}, con sus modelos y plazos forales. Este borrador te sirve de guía; la declaración la prepara tu gestoría.",
    ipsi: "En Ceuta y Melilla se aplica el IPSI en lugar del IVA. NuvliPro todavía no lo calcula: pide a tu gestoría que prepare la declaración.",
  },
  card: {
    baseVentas: "Base ventas", baseGastos: "Base gastos", rep: "{{imp}} repercutido", sop: "{{imp}} soportado",
    irpf: "Retención IRPF", horas: "Horas trabajadas", bases: "Bases por tipo de {{imp}}", base: "{{imp}} {{pct}}% · base",
    resultado: "Resultado {{imp}} ({{estado}})", aIngresar: "a ingresar", aCompensar: "a compensar",
    igicCanarias: "IGIC · obras en Canarias", ivaFuera: "IVA · obras fuera de Canarias",
    ipsiRep: "IPSI repercutido", ipsiAviso: "IPSI sin cálculo: lo prepara tu gestoría.",
    isp: "Inversión del sujeto pasivo · aparte", ispEmitidas: "Emitidas (base, sin cuota)", ispRecibidas: "Recibidas (base)",
    ispCuota: "Cuota autoliquidada (se declara y se deduce)",
  },
  btn: {
    docGestoria: "Doc. gestoría", docAnual: "Doc. gestoría (anual)", enviar: "Enviar", m: "M.{{m}}", modelo: "Modelo {{m}}",
    m420Pro: "Modelo 420: Plan Pro", excel: "Excel", ver130: "Ver 130",
  },
  anual: { titulo: "Resumen anual {{year}}", ipsi: "IPSI repercutido (sin cálculo)", resultado: "Resultado {{imp}} anual" },
  doc: { gestoria: "Documento para gestoría", modelo: "Modelo {{m}}" },
  toast: {
    generado: "{{doc}} generado", trimestre: " (T{{n}})", anual: " (anual {{year}})", error: "No se pudo generar: {{doc}}",
    excelOk: "Informe {{year}} exportado para gestoría (XLSX)", excelError: "No se pudo exportar el informe",
    m130Error: "No se pudo calcular el Modelo 130", reduccionError: "No se pudo guardar la reducción",
  },
  m130: {
    titulo: "Modelo 130 — IRPF", acum: "(acum. {{n}}T)", anual: "(anual {{year}})",
    desc: "Pago fraccionado acumulado del año, menos retenciones y lo ingresado en trimestres anteriores.",
    ingresos: "Ingresos computables (acumulado)", gastos: "Gastos deducibles (acumulado)", rendimiento: "Rendimiento neto",
    reduccion: "Reducción {{pct}} % difícil justificación", pago: "Pago fraccionado ({{pct}} %)",
    retenciones: "Retenciones soportadas", anteriores: "Pagos de trimestres anteriores",
    aIngresar: "Resultado a ingresar", negativo: "Resultado negativo (a ingresar: 0 €)",
    marcar: "Aplicar la reducción del {{pct}} % por gastos de difícil justificación (máx. {{max}}/año). Consúltalo con tu gestoría.",
    cerrar: "Cerrar", pdf: "Descargar PDF",
  },
  m202: {
    titulo: "Modelo 202 — pagos a cuenta {{year}} (estimación)",
    desc: "Impuesto sobre Sociedades: {{pct}} % sobre el beneficio acumulado del año. Tu gestoría puede usar otra modalidad.",
    plazo: "{{p}}P · se presenta del 1 al 20 de {{mes}}", mes: { 1: "abril", 2: "octubre", 3: "diciembre" },
    tramo: { 3: "ene–mar", 9: "ene–sep", 11: "ene–nov" }, beneficio: "Beneficio acumulado ({{tramo}})",
    cuota: "{{pct}} % del beneficio", menos: "Retenciones y pagos anteriores", estimacion: "Estimación a ingresar",
  },
  m111: {
    titulo: "Modelo 111 — retenciones {{year}}",
    desc: "Retenciones de las nóminas (las escribes tú) y de los profesionales a los que pagas con retención (salen de tus gastos).",
    nominas: "Retenciones de nóminas (a mano)", profesionales: "Profesionales: {{n}} perceptor(es), base {{base}}",
    total: "Total a ingresar", guardado: "Retenciones de nóminas del {{n}}T guardadas",
    errorGuardar: "No se pudo guardar el importe", invalido: "Escribe un importe válido, por ejemplo 1.234,56",
  },
  enviar: {
    titulo: "Enviar el {{n}}T {{year}} a tu gestoría",
    desc: "Le llegará un correo con estos PDF adjuntos. Si responde, el correo te llegará a ti.",
    email: "Correo de la gestoría", placeholder: "gestoria@ejemplo.com", boton: "Enviar", ok: "{{n}}T {{year}} enviado a {{email}} ({{docs}} PDF)",
    error: "Revisa el correo de la gestoría",
  },
  avisos: {
    plazos: "Próximos plazos", sinPlazos: "No hay plazos próximos.",
    forales: "Plazos forales: los modelos se presentan en tu Hacienda Foral y los prepara tu gestoría.",
    modelos: "Modelos {{m}}", rango: "{{periodo}}: del {{desde}} al {{hasta}}",
    hoy: "Termina hoy", unDia: "Queda 1 día", dias: "Quedan {{n}} días",
    recordatorio: "Te avisamos por notificación y email 10 días antes de que termine cada plazo.",
    calidad: "Calidad de los datos {{year}}", ok: "Todo en orden: no hemos visto datos que falten en tus facturas de este año.",
    revisar: "Revisar", exenta: "Marcar exenta", exentaOk: "Gasto marcado como exento", exentaError: "No se pudo marcar el gasto",
  },
  calidad: {
    facturas_nif: "Facturas emitidas sin NIF del cliente o con NIF incorrecto",
    facturas_cp_obra: "Facturas de obra sin código postal de la obra (añádelo en la ficha de la obra)",
    gastos_sin_impuesto: "Facturas recibidas sin el impuesto desglosado (IVA o IGIC a 0)",
    gastos_nif: "Facturas recibidas sin NIF del proveedor o con NIF incorrecto",
  },
  ajustes: {
    titulo: "Régimen fiscal (Control Trimestral)", det1: "Detectado automáticamente:", det2: "por tu código postal y",
    det3: "por tu NIF/CIF. Cámbialo solo si no es correcto.",
    nota: "Este cambio solo afecta al Control Trimestral. Las facturas nuevas siguen proponiendo el impuesto según tu código postal y el del cliente.",
    territorio: "Territorio fiscal", tipo: "Tipo de contribuyente", automatico: "Automático ({{x}})",
    autonomo130: "Autónomo (modelo 130)", sociedad202: "Sociedad (modelo 202)",
    bloqueado: "El régimen automático es del Plan Pro.", guardado: "Régimen fiscal guardado", error: "No se pudo guardar",
  },
};

const en = {
  avisoLegal: "Draft for guidance only, generated from the data recorded in NuvliPro. It does not replace professional advice. Review it with your tax advisor before filing it.",
  lockPago: "Exports for your tax advisor are a paid feature.",
  imp: { IVA: "VAT", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Common territory", canarias: "Canary Islands", ceuta_melilla: "Ceuta and Melilla", foral_pv: "Basque Country", foral_navarra: "Navarre" },
  tipo: { autonomo: "Self-employed (individual)", sociedad: "Company" },
  q: { 1: "Q1 · Jan–Mar", 2: "Q2 · Apr–Jun", 3: "Q3 · Jul–Sep", 4: "Q4 · Oct–Dec" },
  periodoT: "Q{{n}} {{year}}",
  periodoP: "Payment {{n}} {{year}}",
  sub: "{{imp}} and income tax per quarter and annual summary",
  pie: "Amounts are calculated automatically from the invoices you issue and the expenses you record each quarter.",
  regimen: {
    proTitulo: "Pro plan:",
    proTexto: "automatic tax regime by territory (VAT, IGIC and foral treasuries), Form 420 in the Canary Islands, Form 202 for companies, Form 111, deadline reminders and data quality checks.",
    pasarPro: "Upgrade to Pro",
    modelo: " (Form {{m}})",
    pagos: "payments on account: Form {{m}}",
    corregido: "Corrected manually · change",
    detectado: "Detected automatically · correct",
    faltan: "Your tax {{que}} is missing: we assume common territory and self-employed until you complete it.",
    cp: "postcode", nif: "NIF/CIF", y: " and ",
    foral: "Your tax address is in {{nombre}}: VAT and payments on account are filed with the {{hacienda}}, using its own foral forms and deadlines. This draft is a guide; your tax advisor prepares the return.",
    ipsi: "In Ceuta and Melilla IPSI applies instead of VAT. NuvliPro does not calculate it yet: ask your tax advisor to prepare the return.",
  },
  card: {
    baseVentas: "Sales base", baseGastos: "Expenses base", rep: "Output {{imp}}", sop: "Input {{imp}}",
    irpf: "Income tax withheld (IRPF)", horas: "Hours worked", bases: "Bases by {{imp}} rate", base: "{{imp}} {{pct}}% · base",
    resultado: "{{imp}} result ({{estado}})", aIngresar: "to pay", aCompensar: "to offset",
    igicCanarias: "IGIC · jobs in the Canary Islands", ivaFuera: "VAT · jobs outside the Canary Islands",
    ipsiRep: "Output IPSI", ipsiAviso: "IPSI not calculated: your tax advisor prepares it.",
    isp: "Reverse charge · shown separately", ispEmitidas: "Issued (base, no tax)", ispRecibidas: "Received (base)",
    ispCuota: "Self-assessed tax (declared and deducted)",
  },
  btn: {
    docGestoria: "Advisor doc.", docAnual: "Advisor doc. (annual)", enviar: "Send", m: "F.{{m}}", modelo: "Form {{m}}",
    m420Pro: "Form 420: Pro plan", excel: "Excel", ver130: "View 130",
  },
  anual: { titulo: "Annual summary {{year}}", ipsi: "Output IPSI (not calculated)", resultado: "Annual {{imp}} result" },
  doc: { gestoria: "Tax advisor document", modelo: "Form {{m}}" },
  toast: {
    generado: "{{doc}} generated", trimestre: " (Q{{n}})", anual: " (annual {{year}})", error: "Could not generate: {{doc}}",
    excelOk: "{{year}} report exported for your tax advisor (XLSX)", excelError: "Could not export the report",
    m130Error: "Could not calculate Form 130", reduccionError: "Could not save the reduction",
  },
  m130: {
    titulo: "Form 130 — Income tax", acum: "(cumulative Q{{n}})", anual: "(annual {{year}})",
    desc: "Cumulative payment on account for the year, minus withholdings and what you paid in previous quarters.",
    ingresos: "Taxable income (cumulative)", gastos: "Deductible expenses (cumulative)", rendimiento: "Net income",
    reduccion: "{{pct}} % hard-to-justify expenses reduction", pago: "Payment on account ({{pct}} %)",
    retenciones: "Withholdings suffered", anteriores: "Payments in previous quarters",
    aIngresar: "Result to pay", negativo: "Negative result (to pay: €0)",
    marcar: "Apply the {{pct}} % reduction for hard-to-justify expenses (max. {{max}}/year). Check with your tax advisor.",
    cerrar: "Close", pdf: "Download PDF",
  },
  m202: {
    titulo: "Form 202 — payments on account {{year}} (estimate)",
    desc: "Corporate income tax: {{pct}} % of the year's cumulative profit. Your tax advisor may use another method.",
    plazo: "Payment {{p}} · filed from 1 to 20 {{mes}}", mes: { 1: "April", 2: "October", 3: "December" },
    tramo: { 3: "Jan–Mar", 9: "Jan–Sep", 11: "Jan–Nov" }, beneficio: "Cumulative profit ({{tramo}})",
    cuota: "{{pct}} % of profit", menos: "Withholdings and previous payments", estimacion: "Estimated amount to pay",
  },
  m111: {
    titulo: "Form 111 — withholdings {{year}}",
    desc: "Payroll withholdings (you enter them) and withholdings on professionals you pay (taken from your expenses).",
    nominas: "Payroll withholdings (manual)", profesionales: "Professionals: {{n}} payee(s), base {{base}}",
    total: "Total to pay", guardado: "Q{{n}} payroll withholdings saved",
    errorGuardar: "Could not save the amount", invalido: "Enter a valid amount, for example 1,234.56",
  },
  enviar: {
    titulo: "Send Q{{n}} {{year}} to your tax advisor",
    desc: "They will receive an email with these PDFs attached. If they reply, the email comes to you.",
    email: "Tax advisor's email", placeholder: "advisor@example.com", boton: "Send", ok: "Q{{n}} {{year}} sent to {{email}} ({{docs}} PDF)",
    error: "Check your tax advisor's email",
  },
  avisos: {
    plazos: "Upcoming deadlines", sinPlazos: "No upcoming deadlines.",
    forales: "Foral deadlines: the forms are filed with your Hacienda Foral and your tax advisor prepares them.",
    modelos: "Forms {{m}}", rango: "{{periodo}}: from {{desde}} to {{hasta}}",
    hoy: "Ends today", unDia: "1 day left", dias: "{{n}} days left",
    recordatorio: "We remind you by notification and email 10 days before each deadline ends.",
    calidad: "Data quality {{year}}", ok: "All good: we found no missing data in this year's invoices.",
    revisar: "Review", exenta: "Mark as exempt", exentaOk: "Expense marked as exempt", exentaError: "Could not update the expense",
  },
  calidad: {
    facturas_nif: "Issued invoices with a missing or invalid client NIF",
    facturas_cp_obra: "Job invoices without the job postcode (add it in the job record)",
    gastos_sin_impuesto: "Received invoices without the tax broken down (VAT or IGIC at 0)",
    gastos_nif: "Received invoices with a missing or invalid supplier NIF",
  },
  ajustes: {
    titulo: "Tax regime (Quarterly Report)", det1: "Detected automatically:", det2: "from your postcode and",
    det3: "from your NIF/CIF. Only change it if it is wrong.",
    nota: "This change only affects the Quarterly Report. New invoices still propose the tax based on your postcode and your client's.",
    territorio: "Tax territory", tipo: "Taxpayer type", automatico: "Automatic ({{x}})",
    autonomo130: "Self-employed (Form 130)", sociedad202: "Company (Form 202)",
    bloqueado: "The automatic regime is part of the Pro plan.", guardado: "Tax regime saved", error: "Could not save",
  },
};

const TRIMESTRAL = { es, en, de, it, nl, fr, ro, ru, ar, zh };
export default TRIMESTRAL;
